import { createFileRoute } from '@tanstack/react-router'
import { ShipmentsPage } from '@/pages/shipments'

export const Route = createFileRoute('/_authenticated/shipments/')({
  staticData: { title: 'Shipments' },
  component: ShipmentsPage,
})
